module.exports = __webpack_public_path__ + "../static/img/fluxity_logo.8ededb6d.png";